import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'customers-summary',
  templateUrl: './customers-summary.component.html',
  styleUrls: ['./customers-summary.component.scss']
})
export class CustomersSummaryComponent implements OnInit {


  @Input() selection: any;

  constructor() {

  }

  ngOnInit(): void {
  }
}
